import { RecordTarget } from "features/RecordTarget/models";
import RecipientTag from "components/Tag/ResourceTargetTag/RecipientTag";

interface RecordTargetTagProps {
  recordTarget: RecordTarget;
  remove?: () => void;
  disabled?: boolean;
}

export default function RecordTargetTag({ recordTarget, remove = () => { }, disabled = false }: RecordTargetTagProps) {
  const { targetId, targetType } = recordTarget || {};
  return <RecipientTag resourceId={targetId} resourceType={targetType} remove={remove} disabled={disabled} />;
}
